<div class="flex justify-between mb-4">
  <div class="text-xl text-gray-700 font-bold">Importação tarifário</div>
  <div class="mr-8 gap-2 flex justify-center">
    <button mat-raised-button class="btn-add" (click)="downloadModelTariff()">
      <mat-icon>download_file</mat-icon>
      Modelo
    </button>
    @if (checkPermission('criar')) {
      <button mat-raised-button class="btn-add" (click)="importTariff()">
        Importar
        <mat-icon>upload_file</mat-icon>
      </button>
    }
  </div>
</div>

<div class="mt-8">
  <div class="mt-4">
    <!--      <form-search [search]="inputSearch" (responseSearch)="search($event)" />-->
    <!--    @if (checkPermission('pesquisar-paginado')) {-->
    <!--    <mat-accordion>-->
    <!--      <mat-expansion-panel>-->
    <!--        <mat-expansion-panel-header>-->
    <!--          <mat-panel-title> Pesquisa </mat-panel-title>-->
    <!--        </mat-expansion-panel-header>-->
    <!--        <div>-->
    <!--          <search-tariff-page-->
    <!--            [searchEvent]="inputSearch"-->
    <!--            (responseSearch)="search($event)"-->
    <!--          />-->
    <!--          &lt;!&ndash;            <form-search-proposal-client&ndash;&gt;-->
    <!--          &lt;!&ndash;              [search]="inputSearch"&ndash;&gt;-->
    <!--          &lt;!&ndash;              (responseSearch)="search($event)"&ndash;&gt;-->
    <!--          &lt;!&ndash;            />&ndash;&gt;-->
    <!--        </div>-->
    <!--      </mat-expansion-panel>-->
    <!--    </mat-accordion>-->
    <!--    }-->
    <div class="mt-4">
      @if (!loading) {
        <div>
          <table-list-simple
            [dataSource]="itemsList"
            [columns]="columns"
            (logItem)="downloadLog($event)"
            (excelItem)="downloadExcel($event)"
          />
          @if (itemsList.length > 0) {
            <mat-paginator
              [length]="numberRows"
              [pageSize]="rows"
              [pageIndex]="page - 1"
              [pageSizeOptions]="[5, 10, 20, 30]"
              (page)="onPageEvent($event)"
            >
            </mat-paginator>
          }
        </div>
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
    </div>
  </div>
</div>
